module.exports = __webpack_public_path__ + "static/media/farm-icon.cf08fe70.svg";